module.exports = __webpack_public_path__ + "static/media/Necchi - Orange_Ind.Blue.4dff18c2.jpg";